module.exports = __webpack_public_path__ + "img/20241023_manavisfesta_02.4fcbc786.jpg";